<template>
  <div class="caption-bar-comp">
    <div class="caption-line"></div>
    <div class="caption-bar__wrapper">
      <div class="caption pos-center" :class="{ white:type=='white' }">{{title}}</div>
      <div class="subCaption" v-if="subTitle">
        <i></i>
        <span>{{subTitle}}</span>
        <i></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title","subTitle",'type'],
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  components: {},
};
</script>

<style scoped lang='less'>
.caption-bar-comp {
  width: 100%;
  position: relative;
  z-index: 2;
  .caption-bar__wrapper {
    position: relative;
    z-index: 2;
    width: 350px;
    margin: 0 auto;
    .caption {
      height: 50px;
      background: var(--unnamed-color-111111);
      box-shadow: 0px 3px 6px #00000029;
      opacity: 1;
      font-size: 24px;
      line-height: 50px;
      letter-spacing: var(--unnamed-character-spacing-12);
      color: var(--unnamed-color-ffffff);
      &.white {
        background: white;
        color: var(--unnamed-color-111111);
        border: 1px solid var(--unnamed-color-111111);
      }
    }
    .subCaption {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 24px;
      i {
        width: 32px;
        height: 0px;
        border: 1px solid#757575;
      }
      span {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: var(--unnamed-color-111111);
      }
    }
  }
  .caption-line {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 25px;
    width: 99%;
    height: 0px;
    height: 2px;
    background: var(--unnamed-color-111111);
  }
  @media (max-width: 992px) {
    .caption-line {
      top: 13px;
    }
    .caption-bar__wrapper {
      width: 170px;
      height: auto;
      .caption {
        font-size: 1rem;
        line-height: 2rem;
        height: auto;
        margin-bottom: 4px;
        text-indent: var(--unnamed-character-spacing-12);
      }
      .subCaption {
        span {
          font-size: 0.5rem;
          transform: scale(.8);
        }
      }
    }
  }
}
</style>
